module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_500_Bold.96e7c59.woff2";